module.exports = __webpack_public_path__ + "static/media/file-edit.1d61f319.svg";